
import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

const header = [
  { label: 'S.N', value: 'S.N' },
  {
    label: 'Date',
    value: 'actualProcessDate1',
  },

  {
    label: 'Batch id',
    value: 'productionId',
  },
  // {
  //   label: 'Facility',
  //   value: 'hubName',
  // },
  // {
  //   label: 'Supply chain',
  //   value: 'franchiseName',
  // },
  {
    label: 'Process',
    value: 'processName',
  },
  {
    label: 'Type',
    value: 'processType',
  },
  // {
  //   label: 'Input',
  //   value: 'inputMaterial',
  // },
  // {
  //   label: 'Quantity',
  //   value: 'inMaterialDetailsQuantity',
  // },
  {
    label: 'Output',
    value: 'productionItemDetails',
  },
  {
    label: 'Quantity',
    value: 'productionItemDetailsQuantity',
  },
  /*   {
    action: ['certificate'],
  }, */
  {
    label: 'Action',
    value: 'assignDDP2',
  },
  {
    action: ['qrr'],
  },
]

const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)

export { roleColumns }
